import { NzModalService } from 'ng-zorro-antd/modal';
import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-organization-profile-modal',
	templateUrl: './organization-profile-modal.component.html',
	styleUrls: ['./organization-profile-modal.component.scss']
})
export class OrganizationProfileModalComponent implements OnInit {

	@Input() organizationDetails: any;
	currentLanguage: string;
	profileUrl = [];

	constructor (
		private modalService: NzModalService,
		private translateService: TranslateService,
	) {
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe(response => {
			this.currentLanguage = response.lang;
		});
	}

	ngOnInit(): void {
		if(this.organizationDetails.profilePicture) {
			this.profileUrl[0] = {
				fileName : this.organizationDetails.profilePicture
			};
		}
	}

	ngOnDestroy(): void {
		this.modalService.closeAll();
	}
}
